import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IReferenceProvider } from '../../../references/interfaces/reference-provider.interface';
import { TableApiService } from '../../../tables/services/table-api.service';
import { IDataSourceSettings } from '../../interfaces/data-source-settings.interface';
import { DataSourceSettingsRef } from '../../interfaces/data-source-settings.token';
import { IUIDataSourceItemInitial } from '../interfaces/ui-data-source-item';

@Injectable({
  providedIn: 'root',
})
export class NewDataSourceItemsService extends TableApiService<IUIDataSourceItemInitial> implements IReferenceProvider {
  constructor(
    protected httpClient: HttpClient,
    @Inject(DataSourceSettingsRef) dataSourceSettings: IDataSourceSettings
  ) {
    super(httpClient, `${dataSourceSettings.dataServiceApi}`);
  }
}
